import { useCallback } from "react";
import type { ApiError } from "@Front/Hooks/useApiClientTypes";
import { handleApiErrorResponse } from "@Front/Hooks/useApiClientRequestCore";

export function useApiErrorHandler(): (
	response: Response,
	errorMessage?: string,
	logErrors?: boolean,
) => Promise<ApiError> {
	return useCallback(
		async (response: Response, errorMessage?: string, logErrors: boolean = true): Promise<ApiError> => {
			return await handleApiErrorResponse(response, errorMessage, logErrors);
		},
		[],
	);
}
